<template>
  <v-timeline
    align-top
    :dense="$vuetify.breakpoint.smAndDown"
    class="mb-10"
    dark
  >
    <v-timeline-item
      v-for="(item, i) in items"
      :key="i"
      :color="item.color"
      :icon="item.icon"
      fill-dot
    >
      <v-card
        :color="item.color"
        dark
      >
        <v-card-title class="title" :class="item.justify">
          {{ item.title }}
        </v-card-title>
        <v-card-text class="white text--primary">
          <p class="pt-3 mb-0">{{ item.text }}</p>
        </v-card-text>
      </v-card>
    </v-timeline-item>
  </v-timeline>
</template>

<script>
  export default {
    name: 'Intro',
    data: () => ({
      items: [
        {
          color: 'purple darken-1',
          icon: 'mdi-new-box',
          title: 'Nuovo esame',
          text:'Le modalità di esame sono cambiate!!!',
          justify: 'justify-md-start'
        },
        {
          color: 'red lighten-2',
          icon: 'mdi-help-rhombus-outline',
          title: '15 Domande A/B/C',
          text:'Nelle domande a risposta multipla troverai tre risposte: scegli quella corretta',
          justify: 'justify-md-end'
        },
        {
          color: 'green lighten-1',
          icon: 'mdi-head-sync',
          title: 'Verifica le tue risposte',
          text:'Nella verifica potrai controllare le risposte che hai dato: quelle corrette saranno evidenziate in verde, mentre le eventuali sbagliate saranno indicate in rosso, con la risposta giusta scritta in verde.',
          justify: 'justify-md-start'
        },
        {
          color: 'indigo',
          icon: 'mdi-restart',
          title: 'Ripeti',
          text:'Puoi esercitarti liberamente per migliorare i tuoi progressi',
          justify: 'justify-md-end'
        },
      ],
    }),
  }
</script>
